module.exports = __webpack_public_path__ + "static/media/ttc-logo.d1723706.svg";